'use strict';

const scriptMap = {};

function handleScript({url, script}) {
  if (!scriptMap[url]) {
    scriptMap[url] = script;
  }
}

function btyesToString(ab) {
  if (typeof TextDecoder !== 'undefined') {
    try {
      const td = new TextDecoder();
      return td.decode(ab);
    } catch (e) {
      // empty
    }
  }
  try {
    //eslint-disable-next-line no-undef
    return String.fromCharCode.apply(null, new Uint8Array(ab));
  } catch (e) {
    // empty
  }
  return null;
}

function importScripts(url) {
  const script = scriptMap[url];
  if (script) {
    delete scriptMap[url];
    const code = btyesToString(script);
    if (code) {
      //eslint-disable-next-line no-eval
      eval.call(null, code);
      return;
    }
  }
  self.importScripts(url);
}

module.exports = {
  handleScript,
  importScripts
};



// WEBPACK FOOTER //
// ./src/main/worker/scriptHandler.js